import { RiCloseLine } from '@remixicon/react';
import { RemixIcon } from '../Icon/RemixIcon';
import { alertGridAreaClose } from './constants';
import { Button } from '@upheal/design-system/components/Button/Button';
import { useSlotContext } from '../../utils/useSlotContext';
import {
    DesignSystemAlertSize,
    DesignSystemIconSizing,
} from '@upheal/design-system/theme/design-system/types';

const mapAlertSizeToIconSize: Record<
    DesignSystemAlertSize,
    DesignSystemIconSizing
> = {
    xs: 'xs',
    sm: 'sm',
    md: 'md',
};

type Props = {
    onClose: VoidFunction;
};

export const AlertClose = (props: Props) => {
    const { size, closeExtraGap } = useSlotContext(props, 'alert');
    const iconSize = mapAlertSizeToIconSize[size ?? 'sm'] ?? 'sm';

    const { onClose } = props;

    return (
        <Button
            aria-label="Close alert"
            colorScheme="neutral"
            iconOnly
            onClick={onClose}
            sx={{
                gridArea: alertGridAreaClose,
                p: 0,
                height: 'fit-content',
                width: 'fit-content',
                minWidth: 'fit-content',
                ...(closeExtraGap && { marginLeft: closeExtraGap }),
            }}
            variant="link"
        >
            <RemixIcon icon={RiCloseLine} size={iconSize} />
        </Button>
    );
};
